<template>
  <AppContainer max-width="max-w-6xl -mt-[2px]">
    <ul class="flex flex-wrap gap-2 font-medium w-full">
      <li
        v-for="(section, index) in planStore.vision"
        :key="index"
        class="border border-b-0 rounded-t overflow-hidden mt-[2px] min-w-[130px]"
      >
        <span
          :data-text="section.heading"
          class="flex flex-col items-center
          after:content-[attr(data-text)] after:block after:font-medium after:invisible after:h-0 after:overflow-hidden
          no-underline bg-[#DEE3E7] text-gray-700 px-4 py-[10px] text-center !text-sm whitespace-nowrap
          font-normal hover:text-gray-600 hover:bg-gray-300 block pb-[12px] relative z-[0] cursor-pointer"
          :class="{ '!text-black !bg-white !font-medium z-[2]': activeTabUI === index }"
          @click="changeTab(index)"
        >
          {{ section.heading }}
        </span>
      </li>
    </ul>

    <AppCard class="rounded-tr relative z-[1] -top-[1px] min-h-[62vh]">
      <AppContentLoader v-if="loadingTab" />

      <template v-else>
        <TextEditorInput
          v-for="(question, index) in planStore.vision[selectedIndex].questions"
          :id="`question-${index}-content`"
          :key="index"
          v-model="question.content"
          :label="question.question"
          recommended-word-count="300 - 400"
          :word-limit="500"
        />
      </template>
    </AppCard>
  </AppContainer>
</template>

<script setup>
import { ref, nextTick } from 'vue';

import { AppContainer, AppContentLoader } from '@/components/app/index.js';
import { usePlanStore } from '@/store/index.js';
import { TextEditorInput } from '@/components/form-inputs/index.js';
import { AppCard } from '@/components/cards/index.js';

defineProps({
  frameworks: {
    type: Array,
    default: () => [],
  },
});

const planStore = usePlanStore();

const activeTabUI = ref(0);
const selectedIndex = ref(0);
const loadingTab = ref(false);

const changeTab = (index) => {
  if (activeTabUI.value === index) return;

  activeTabUI.value = index;
  loadingTab.value = true;

  requestAnimationFrame(() => {
    setTimeout(() => {
      selectedIndex.value = index;

      nextTick(() => {
        setTimeout(() => {
          loadingTab.value = false;
        }, 150);
      });
    }, 10);
  });
};
</script>
